import { Component, h } from 'preact';

import { TimerIcon } from './icon';
import { connect } from 'redux-zero/preact';
import actions from '../store/actions';
import { $lang } from '../plugins/helper';

const mapToProps = ({ etest, type, devMode, attempt_of_test }) => ({ etest, type, devMode, attempt_of_test })

class Timer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            minutes: 0,
            seconds: 0
        }
    }

    componentDidMount() {
        this.startTime()
    }

    /**
     * Count time when component ready
     *
     * @return {void}
     */
    startTime() {
        let timer = this.props.etest.meta_info.timer;
        let mins = Math.floor(timer / 60);
        let secs = Math.floor(timer - mins * 60);
        this.setState({
            minutes: mins,
            seconds: secs
        })

        this.myInterval = setInterval(() => {
            const { seconds, minutes } = this.state;
            const { attempt_of_test } = this.props;
            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    this.props.setFinishTest(true);

                    if (this.props.etest.attempt == 3 || this.props.type == 'et') {
                        this.props.errorAdd($lang('error.timeout'));
                    }

                    if (this.props.type == 'et') {
                        this.props.submitQuestion();
                    } else {
                        if (this.props.etest.attempt == attempt_of_test) {
                            this.props.submitQuestion();
                        }
                    }

                    clearInterval(this.myInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    render() {
        const { minutes, seconds } = this.state;
        return (
            <button className="neo-btn-icon-text timer notranslate">
                <TimerIcon />
                <div className="timer-counter et-ml-2 et-mr-1">
                    {minutes < 10 ? "0" + minutes : minutes}:{seconds < 10 ? "0" + seconds : seconds}
                </div>
            </button>
        )
    }
}

export default connect(mapToProps, actions)(Timer)